export type ResourceType =
  | 'flag'
  | 'metric'
  | 'abtest'
  | 'rollout'
  | 'analysis'
  | 'pulse';

export const EXPERIMENT_TYPES: ResourceType[] = [
  'abtest',
  'rollout',
  'analysis',
];

export interface SearchResultItem {
  resourceType: ResourceType;
  name: string;
  displayName: string;
  state: string | undefined;
  ownerName: string | undefined;
  createTime: string | undefined;
  updateTime: string | undefined;
  plannedStartTime?: string | null;
  plannedEndTime?: string | null;
  workflowState?: {
    state: string;
    pendingTransition: boolean;
    hasFailedChecks: boolean;
  };
}

export interface UseResourceSearchOptions {
  filterString: string;
  activeTypes: ResourceType[];
  skip: boolean;
  pageSize?: number;
}

export interface UseResourceSearchResult {
  results: SearchResultItem[];
  isLoading: boolean;
  isRefetching: boolean;
  isEmpty: boolean;
  hasNextPage: boolean;
  loadMore: () => void;
  isLoadingMore: boolean;
}
